// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"b4a39ce8","154":"353d39b0","414":"dbf0e2a1","453":"64aababc","730":"84a9c254","788":"ee5722fd","878":"e90d2e72","884":"b32d503e"}[chunkId] + ".chunk.js";
};